import styled from 'styled-components';
import { CurrencyFormat } from '@lt/components';

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
`;

export const BasePriceLabel = styled.div`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;

  color: #17181a;
`;

export const BasePrice: typeof CurrencyFormat = styled(CurrencyFormat)`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #17181a;
`;

export const AdditionalPriceLabel = styled.div`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4d4d4d;
`;

export const AdditionalPrice: typeof CurrencyFormat = styled(CurrencyFormat)`
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  color: #17181a;
  background-color: #f8e71c;
  border-radius: 10px;
  padding-right: 8px;
  padding-left: 8px;
`;
